import { Stack } from "@mui/material";
import type { FC } from "react";
import { NotificationCenterListBar } from "web_myplann/NotificationCenter/Components/NotificationCenterListBar";
import { NotificationCenterTabContent } from "web_myplann/NotificationCenter/Components/NotificationCenterTabContent";
import type { NotificationCenterTab } from "web_myplann/NotificationCenter/Constants/notificationCenterTabs";

type Props = {
	activeTab: NotificationCenterTab;
};

export const NotificationCenterV2Body: FC<Props> = ({ activeTab }) => (
	<Stack flex={1} data-testid="notification-center-page">
		<NotificationCenterListBar activeTab={activeTab} disableBottomPadding />
		<NotificationCenterTabContent activeTab={activeTab} />
	</Stack>
);
